module.exports = __webpack_public_path__ + "img/img11.3ba1f8b4.svg";